import React from 'react'
import "./feedbackSection.css"
import Rating from '@mui/material/Rating';
import { useState } from "react"
const FeedbackSection = () => {
    const [ starValue, setStarValue ]  = useState(0)
  return (
        <section className="feedback-section">
            <div className="feedback-wrapper">
                <form className="feedback-form">
                    <h1>feedback</h1>
                    <div className="input-container">
                        <input type="email" placeholder="your email"/>
                    </div>
                    <div className="textarea-container">
                        <textarea name="feedback" id="feedback" placeholder="feedback"/>
                    </div>
                    <button type="submit" className="feedback-btn">submit</button>
                </form>
                <div className="rate-section">
                    <h1>Rate webiste</h1>
                    <div className="rating-container">
                    <Rating
                        name="simple-controlled"
                        value={starValue}
                        onChange={(event, newValue) => {
                        setStarValue(newValue);
                        }}
                        sx={{
                            '& .MuiRating-icon':{
                                fontSize: '4rem'
                            }
                        }}
                    />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeedbackSection